import { find } from '@/api/favicon.api'
import decoder from '@/decoders/favicon'
import useAPI from '../useAPI'

export const useFavicon = (params = {}) => useAPI({
  request: find,
  params,
  decoder
})
